/**
 * Service to manage teacher data.
 */
import { inject, Injectable } from '@angular/core';

import { Teacher, User } from '../../models';
import { HttpService } from '../core/http.service';
import { IsophiCoreService } from '../core/isophi-core.service';

@Injectable({
  providedIn: 'root'
})
export class TeacherService {
  protected readonly httpService = inject(HttpService);
  protected readonly isophiCoreService = inject(IsophiCoreService);

  /**
   * This method download and save teacher data into User entity.
   *
   * @param user
   * @param accessToken
   * @return true/false if data was successfully downloaded
   */
  public loadTeacherData(user: User, accessToken: string): Promise<boolean> {
    const appApi = this.isophiCoreService.appApi;
    const url = `${appApi}/users/${user.id}/teacher/`;

    return this.httpService
      .get(url, accessToken)
      .toPromise()
      .then((response) => {
        if (response.status !== 200) return false;

        const data = response.body;
        Teacher.deserialize(data, user);
        return true;
      })
      .catch(() => false);
  }
}
